<svg viewBox="0 0 24 24" fill="none" aria-hidden="true">
  <path d="M12 4V12" stroke="currentColor" stroke-width="1.75" stroke-linecap="round" />
  <path
    d="M7.5 7.5C6.09 8.9 5.25 10.85 5.25 13C5.25 16.7279 8.2721 19.75 12 19.75C15.7279 19.75 18.75 16.7279 18.75 13C18.75 10.85 17.91 8.9 16.5 7.5"
    stroke="currentColor"
    stroke-width="1.75"
    stroke-linecap="round"
  />
</svg>
